<script>
    import { Route } from 'svelte-navigator';
    
    export let path;
</script>

<Route exact {path} let:params let:location let:navigate>
    <slot {params} {location} {navigate} />
</Route>